import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mapto";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as DTOS from "../FeralScan.dtos";
import { GET_PLOTS_REQUEST, GET_PLOT_EVENTS_REQUEST, GET_PLOT_SEASON_SUMMARY_DATA_REQUEST, GET_PLOT_SUMMARY_DATA_REQUEST, GET_SINGLE_PLOT_REQUEST, GET_SUMMARY_DATA_REQUEST, GET_USER_PLOTS_REQUEST, IGetPlotEventsRequestAction, IGetPlotSeasonSummaryDataRequestAction, IGetPlotSummaryDataRequestAction, IGetPlotsRequestAction, IGetSinglePlotRequestAction, IGetSummaryDataRequestAction, IGetUserPlotsRequestAction, ISearchRequestAction, SEARCH_REQUEST, getPlotEventsSuccess, getPlotSeasonSummaryDataSuccess, getPlotSummaryDataSuccess, getPlotsSuccess, getSinglePlotSuccess, getSummaryDataSuccess, getUserPlotsSuccess, searchSuccess, GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_REQUEST, IGetUserPlotEventSummaryDataRequestAction, getUserPlotEventSummaryDataSuccess, getUserPlotsFail } from "../actions/data.actions";
import * as ErrorHandler from "../common/errorHandler";
import { serviceApi } from "../services/data.service";

export const search = action$ =>
    action$
        .ofType(SEARCH_REQUEST)
        .mergeMap((action: ISearchRequestAction) =>
            serviceApi
                .search(action.filters)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(searchSuccess(response))
                    )
                })
                .catch((error: DTOS.SearchResponse) => ErrorHandler.FireErrorActions(error))
        );

export const getPlotSeasonSummaryData = action$ =>
    action$
        .ofType(GET_PLOT_SEASON_SUMMARY_DATA_REQUEST)
        .mergeMap((action: IGetPlotSeasonSummaryDataRequestAction) =>
            serviceApi
                .getPlotSeasonSummaryData(action.plotId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getPlotSeasonSummaryDataSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const getPlotSummaryData = action$ =>
    action$
        .ofType(GET_PLOT_SUMMARY_DATA_REQUEST)
        .mergeMap((action: IGetPlotSummaryDataRequestAction) =>
            serviceApi
                .getPlotSummaryData(action.plotIds, action.classifications, action.plotEventDateStart, action.plotEventDateEnd)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getPlotSummaryDataSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
    );

export const getUserPlotEventSummaryData = action$ =>
    action$
        .ofType(GET_PLATYPUS_USER_PLOTEVENT_SUMMARY_DATA_REQUEST)
        .mergeMap((action: IGetUserPlotEventSummaryDataRequestAction) =>
            serviceApi
                .getUserPlotEventSummaryData()
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getUserPlotEventSummaryDataSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
    );

export const getPlotEvents = action$ =>
    action$
        .ofType(GET_PLOT_EVENTS_REQUEST)
        .mergeMap((action: IGetPlotEventsRequestAction) =>
            serviceApi
                .getPlotEvents(action.plotId, action.userId, action.limit, action.createdDateStart, action.createdDateEnd)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getPlotEventsSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const getPlots = action$ =>
    action$
        .ofType(GET_PLOTS_REQUEST)
        .mergeMap((action: IGetPlotsRequestAction) =>
            serviceApi
                .getPlots(action.createdDateStart, action.createdDateEnd, action.plotEventDateStart, action.plotEventDateEnd, action.plotStatusCodesToInclude)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getPlotsSuccess(response)),
                        //Observable.of(getPlotEventsRequest(response.plots.map(p => p.id)))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const getSinglePlot = action$ =>
    action$
        .ofType(GET_SINGLE_PLOT_REQUEST)
        .mergeMap((action: IGetSinglePlotRequestAction) =>
            serviceApi
                .getSinglePlot(action.plotId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getSinglePlotSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );

export const getSummaryData = action$ =>
    action$
        .ofType(GET_SUMMARY_DATA_REQUEST)
        .mergeMap((action: IGetSummaryDataRequestAction) =>
            serviceApi
                .getSummaryDataByClassification(action.classificationTypes, action.questionCode, action.plotId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getSummaryDataSuccess(response))
                    );
                })
                .catch(error => ErrorHandler.FireErrorActions(error))
        );

export const getUserPlots = action$ =>
    action$
        .ofType(GET_USER_PLOTS_REQUEST)
        .mergeMap((action: IGetUserPlotsRequestAction) =>
            serviceApi
                .getUserPlots(action.includePlotEvents, action.specificUserId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getUserPlotsSuccess(response))
                    )
                })
                .catch(
                    (error) => concat$(Observable.of(getUserPlotsFail()), ErrorHandler.FireErrorActions(error), )
                )
        )